import { defineComponent as _defineComponent } from 'vue'
import {
  TUIStore,
  StoreName,
} from "@tencentcloud/chat-uikit-engine";
import router from "./router/index";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

TUIStore.watch(StoreName.USER, {
  kickedOut: (value: string) => {
    if (value && router.currentRoute.name !== 'login') {
      localStorage.removeItem("TUIKit-userInfo");
      router.replace({ name: "login" });
    }
  },
});

return { __sfc: true, }
}

})